import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || '';

const axiosInstance = axios.create({
  baseURL: apiUrl,
  timeout: 30000, // 30 seconds - enough for Cloud Run cold starts
  headers: {
    'Content-Type': 'application/json',
  }
});

export default axiosInstance;